import {gsap} from "gsap";
import Splide from "@splidejs/splide";
import {AutoScroll} from "@splidejs/splide-extension-auto-scroll";
import { generalStore } from "./GeneralStore.js";

export class Services {
    list = document.querySelector(".horizontal-list");
    items = Array.from(document.querySelectorAll(".splide-services__list > *"));


    initServicesAnimations() {
        document.addEventListener( 'DOMContentLoaded', function() {
            if (document.querySelector('.splide__services')) {
                let servicesSplide = new Splide( '.splide__services', {
                    type: 'loop',

                    perPage: 3,
                    perMove: 1,
                    focus  : 'center',
                    arrows: false,
                    pagination: false,
                    autoScroll: {
                        speed: 3,
                        pauseOnHover: true,
                        pauseOnFocus: true,
                    },
                    autoWidth: true,
                    breakpoints: {
                        769: {
                            padding: {left: '100px', right: '100px'},
                        }
                    }
                } );

                servicesSplide.mount({AutoScroll});
            }
        } );
    }

    initCenterObserver() {
        // Use the items captured at class construction — BEFORE Splide mounts
        // and injects loop-mode clones. Observing clones would fire showImage
        // with an index that doesn't map to a real .img-slide.
        if (!this.items || this.items.length === 0) return;

        // Shrink the root to a narrow vertical band at viewport center so
        // items fire isIntersecting only while crossing the middle. A zero-
        // width band (-50% / -50%) would yield intersectionRatio = 0 and
        // never fire, so we leave a 2% band (-49% / -49%).
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const item = entry.target;
                const index = this.items.indexOf(item);
                if (index < 0) return;

                const filled = item.querySelector('.filled-text');
                const outlined = item.querySelector('.outlined-text');

                if (entry.isIntersecting) {
                    if (filled && outlined) {
                        outlined.classList.add('hidden');
                        filled.classList.remove('hidden');
                    }
                    if (generalStore.state.currentLink !== index) {
                        this.showImage(index);
                        generalStore.state.currentLink = index;
                    }
                } else if (filled && outlined) {
                    filled.classList.add('hidden');
                    outlined.classList.remove('hidden');
                }
            });
        }, {
            rootMargin: '0px -49% 0px -49%',
            threshold: 0,
        });

        this.items.forEach((item) => observer.observe(item));
    }

    showImage(index) {
        const slides = document.querySelectorAll('.img-slide');
        const incoming = slides[index];
        const outgoing = slides[generalStore.state.currentLink];

        if (!incoming) return;

        const tl = gsap.timeline();

        if (index > generalStore.state.currentLink) {
            tl.fromTo(incoming, {
                x: 1000,
                y: -200,
                opacity: 0,
                rotate: -4,
            }, {
                x: 0,
                y: 0,
                opacity: 1,
                rotate: 4,
                duration: 1,
                ease: 'power3.out',
            });

            if (outgoing) {
                tl.to(outgoing, {
                    x: -1000,
                    y: 200,
                    opacity: 0,
                    rotate: -4,
                    duration: 1,
                    ease: 'power3.in',
                }, 0);
            }
        } else {
            tl.fromTo(incoming, {
                x: -1000,
                y: -200,
                opacity: 0,
                rotate: 4,
            }, {
                x: 0,
                y: 0,
                opacity: 1,
                rotate: -4,
                duration: 1,
                ease: 'power3.out',
            });

            if (outgoing) {
                tl.to(outgoing, {
                    x: 1000,
                    y: 200,
                    opacity: 0,
                    rotate: 4,
                    duration: 1,
                    ease: 'power3.in',
                }, 0);
            }
        }

    }
}
